module.exports = __webpack_public_path__ + "static/x86.e8b32338.png";